import { env } from './env';
import { getToken } from './auth';

export const authExpiredEvent = 'verena-livetask:auth-expired';
const requestTimeoutMs = 30_000;

export interface ApiResult {
  ok: boolean;
  error?: string;
  code?: number;
}

export async function api<T extends ApiResult>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');
  const token = getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (!navigator.onLine)
    return { ok: false, error: 'NETWORK_OFFLINE', code: 0 } as T;
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), requestTimeoutMs);
  let response: Response;
  try {
    response = await fetch(`${env.apiUrl}${path}`, { ...options, headers, signal: controller.signal });
  } catch {
    return { ok: false, error: navigator.onLine ? 'NETWORK_TIMEOUT' : 'NETWORK_OFFLINE', code: 0 } as T;
  } finally {
    window.clearTimeout(timeout);
  }
  const payload: unknown = await response.json().catch(() => ({ ok: false, error: 'Invalid server response' }));
  if (
    response.status === 401 &&
    token &&
    path !== '/auth/login' &&
    path !== '/auth/logout' &&
    path !== '/auth/me'
  ) {
    window.dispatchEvent(new Event(authExpiredEvent));
  }
  if (typeof payload !== 'object' || payload === null || !('ok' in payload)) {
    return { ok: false, error: 'Invalid server response', code: response.status } as T;
  }
  return { ...payload, code: response.status } as T;
}
